import { useState } from "react";
import { useReveal } from "../hooks/useReveal";

const ContactForm = () => {
  const [completed, setCompleted] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [ref, visible] = useReveal(0.15);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name || !message) return;

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: "45f939a6-7454-41a6-9b3a-718154996e68",
          name,
          message,
        }),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      setCompleted(true);
    } catch (error: any) {
      console.error("Error submitting data:", error.message);
    }
  };

  return (
    <section ref={ref} className="w-full bg-orange-600 text-white px-2 md:px-8 border-t-3 border-black">
      <div className="max-w-[1500px] mx-auto py-20 px-4 md:px-12">
        {completed ? (
          <div className={`text-center py-12 ${visible ? "reveal-scale" : "reveal-hidden"}`}>
            <p className="text-4xl md:text-5xl font-black uppercase tracking-tight">
              Message received.
            </p>
            <p className="text-lg mt-4 text-orange-100">I'll get back to you.</p>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {/* Left — big CTA headline */}
            <div className={`lg:w-[45%] flex flex-col justify-center gap-6 ${visible ? "reveal-left" : "reveal-hidden"}`}>
              <p className="text-2xl font-black uppercase tracking-tight">
                Contact
                <span className="text-black">.</span>
              </p>
              <div className={`w-16 h-1 bg-black ${visible ? "line-grow delay-200" : "reveal-hidden"}`} />
              <p className="text-3xl md:text-4xl font-black uppercase tracking-tighter leading-[0.9]">
                Let's
                <br />
                get
                <br />
                in touch.
              </p>
              <div className="flex flex-col gap-3 mt-4">
                <div>
                  <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-200 block">
                    Email
                  </span>
                  <a
                    href="mailto:ariesmatteo@gmail.com"
                    className="font-bold border-b border-white hover:border-black hover:text-black transition-colors"
                  >
                    ariesmatteo@gmail.com
                  </a>
                </div>
                <div>
                  <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-200 block">
                    Location
                  </span>
                  <span className="font-bold">Switzerland</span>
                </div>
              </div>
            </div>

            {/* Right — form in white card */}
            <div className={`lg:w-[55%] ${visible ? "reveal-right delay-200" : "reveal-hidden"}`}>
              <form
                onSubmit={handleSubmit}
                className="border-3 border-black bg-white text-black p-6 md:p-8 shadow-[8px_8px_0px_0px_#000] flex flex-col gap-5"
              >
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="name"
                    className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={name}
                    className="w-full p-3 border-3 border-black focus:border-orange-600 focus:outline-none bg-gray-50 transition-colors"
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="message"
                    className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400"
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={message}
                    rows={5}
                    className="w-full p-3 border-3 border-black focus:border-orange-600 focus:outline-none bg-gray-50 resize-none transition-colors"
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
                <button type="submit" className="self-start px-8 py-3 border-3 border-black bg-black text-white font-black uppercase tracking-wide shadow-[4px_4px_0px_0px_#ea580c] hover:shadow-none hover:translate-x-1 hover:translate-y-1 transition-all">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactForm;
